const Joi = require("joi");

const registerSchema = Joi.object({
  userName: Joi.string().trim().alphanum().min(3).max(50).required().messages({
    "string.base": "User Name must be a string.",
    "string.alphanum": "User Name must only contain alphanumeric characters.",
    "string.min": "Minimum 3 characters required.",
    "string.max": "User Name must be at most {#limit} characters long.",
    "any.required": "Please enter Username.",
    "string.empty": "Please enter Username.",
  }),

  email: Joi.string()
  .trim()
  .pattern(
    new RegExp(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    )      
  )
  .required()
  .messages({
    "string.pattern.base": "Please enter valid e-mail.",
    "any.required": "Please enter e-mail.",
    "string.empty": "Please enter e-mail.",
  }),

  confirmEmail: Joi.string()
  .required()
  .custom((value, helpers) => {
    const { email } = helpers.state.ancestors[0];
    if (!email) {
      return helpers.error("any.required", { custom: "Please enter e-mail first." });
    }
    if (value !== email) {
      return helpers.error("any.only", { custom: "E-mail and Confirm E-mail must match." });
    }
    return value;
  })
  .messages({
    "any.only": "E-mail and Confirm E-mail must match.",
    "any.required": "Please enter confirm e-mail.",
    "string.empty": "Please enter confirm e-mail.",
  }),

  userPassword: Joi.string()
    .pattern(
      new RegExp(
        /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/
      )      
    )
    .required()
    .messages({
      "string.pattern.base":
        "Password should contain letter, numbers and minimum 8 characters.",
      "any.required": "Please enter password.",
      "string.empty": "Please enter password.",
    }),

    confirmPassword: Joi.string()
    .required()
    .custom((value, helpers) => {
      const { userPassword } = helpers.state.ancestors[0];
      if (!userPassword) {
        return helpers.error("any.required", { custom: "Please enter password first." });
      }
      if (value !== userPassword) {
        return helpers.error("any.only", { custom: "Password and Confirm Password must match." });
      }
      return value;
    })
    .messages({
      "any.only": "Password and Confirm Password must match.",
      "any.required": "Please enter confirm password.",
      "string.empty": "Please enter confirm password.",
    }),

    
  firstName: Joi.string()
    .trim()
    .pattern(/^[A-Za-z0-9]+$/)
    .min(3)
    .max(50)
    .required()
    .messages({
      "string.base": "First Name must be a string.",
      "string.pattern.base":
        "First Name must only contain alphanumeric characters.",
      "string.min": "Minimum 3 characters required.",
      "string.max": "First Name must be at most {#limit} characters long.",
      "any.required": "Please enter first name.",
      "string.empty": "Please enter first name.",
    }),

  lastName: Joi.string()
    .trim()
    .pattern(/^[A-Za-z0-9]+$/)
    .min(3)
    .max(50)
    .required()
    .messages({
      "string.base": "Last Name must be a string.",
      "string.pattern.base":
        "Last Name must only contain alphanumeric characters.",
      "string.min": "Minimum 3 characters required.",
      "string.max": "Last Name must be at most {#limit} characters long.",
      "any.required": "Please enter last name.",
      "string.empty": "Please enter last name.",
    }),

  gender: Joi.number()
    .valid(1, 2) // Allow only 1 and 2 as valid values
    .required()
    .messages({
      "number.base": "Please select gender.",
      "any.only": "Please select gender.",
      "any.required": "Please select gender.",
      "string.empty": "Please select gender.",
    }),

  address1: Joi.string().trim().min(1).max(100).required().messages({
    "string.base": "Address Line 1 must be a string.",
    "string.min": "Address Line 1 must be at least {#limit} characters long.",
    "string.max": "Address Line 1 must be at most {#limit} characters long.",
    "any.required": "Please enter address 1.",
    "string.empty": "Please enter address 1.",
  }),

  city: Joi.string().trim().min(1).max(50).required().messages({
    "string.base": "City must be a string.",
    "string.min": "City must be at least {#limit} characters long.",
    "string.max": "City must be at most {#limit} characters long.",
    "any.required": "Please enter city.",
    "string.empty": "Please enter city.",
  }),

  stateName: Joi.number()
    // .valid(1, 2) // Allow only 1 and 2 as valid values
    .required()
    .messages({
      "number.base": "Please select state.",
      "any.only": "Please select state.",
      "any.required": "Please select state.",
      "string.empty": "Please select state.",
    }),

  zip: Joi.string()
    .pattern(new RegExp("^[0-9]{5}$"))
    .required()
    .messages({
      "string.pattern.base":
      "ZIP should contain 5 digits.",
      "any.required": "Please enter ZIP.",
      "string.empty": "Please enter ZIP.",
    }),

  cellPhone: Joi.string()
    .pattern(new RegExp("^\\(\\d{3}\\) \\d{3}-\\d{4}$"))
    .required()
    .messages({
      "string.pattern.base": "Please enter valid phone number.",

      "any.required": "Please enter phone number.",
      "string.empty": "Please enter phone number.",
    }),

  isTeamsConditionVerified: Joi.boolean().valid(true).required().messages({
    "any.only": "You must agree to the terms of service.",
    "any.required": "You must agree to the terms of service.",
  }),

  isAgeVerified: Joi.number().valid(1).required().messages({
    "any.only": "You must confirm that you are above 18 years old.",
    "any.required": "You must confirm that you are above 18 years old.",
  }),
  
  
}).unknown(true);

module.exports = registerSchema;
